import * as React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {AiHomepage} from '../../ui/ai-home/ai-homepage';
import {FeaturePage} from '../../ui/ai-home/features/feature-page';
import {AI_FEATURES} from '../../ui/ai-home/features/features-list';
import {WelcomePage} from '../../ui/ai-home/welcome-page/welcome-page';
import {readLocalStorage} from '../../util/localStorage';

import {RestrictedRoute} from '../shared/restricted-route';

export function AiHomeRoot() {
    const hasUserVisitedAiHomepage = Boolean(
        readLocalStorage(Nut_Settings_User.SETTING_HAS_USER_VISITED_AI_HOMEPAGE) === 'true' ||
            NutClientConfig.hasUserVisitedAiHomepage
    );
    const hasAccessToHomepage = NutClientConfig.hasAiHomepageFF && hasUserVisitedAiHomepage;

    let homepageRedirectPath = '/sales/dashboard';
    if (NutClientConfig.hasAiHomepageFF && !hasUserVisitedAiHomepage) {
        homepageRedirectPath = '/ai/home/welcome';
    }

    return (
        <Switch>
            <RestrictedRoute
                path='/ai/home/welcome'
                hasAccess={NutClientConfig.hasAiHomepageFF}
                redirectPath='/sales/dashboard'
                render={() => <WelcomePage />}
            />
            <RestrictedRoute
                path='/ai/home/:featureName'
                hasAccess={hasAccessToHomepage}
                redirectPath={homepageRedirectPath}
                render={(routeProps) => {
                    const featureName = routeProps.match.params.featureName;
                    if (!featureName) {
                        return <Redirect to='/ai/home' />;
                    }

                    const feature = AI_FEATURES.find((f) => f.pathSegment === featureName);

                    if (!feature) {
                        return <Redirect to='/ai/home' />;
                    }

                    return <FeaturePage feature={feature} {...routeProps} />;
                }}
            />
            <RestrictedRoute
                path='/ai/home'
                hasAccess={hasAccessToHomepage}
                redirectPath={homepageRedirectPath}
                render={(routeProps) => <AiHomepage {...routeProps} />}
            />
        </Switch>
    );
}
